import { z } from 'zod'

export const UsernameSchema = z
	.string({ required_error: 'Usuario es requerido.' })
	.min(3, { message: 'El usuario es muy corto.' })
	.max(20, { message: 'El usuario es muy largo.' })
	.regex(/^[a-zA-Z0-9_]+$/, {
		message: 'El usuario solo puede contener letras, números o guión bajo (_)',
	})
	// los usuarios pueden escribir el nombre de usuario en cualquier caso, pero lo almacenamos en minúsculas
	.transform(value => value.toLowerCase())

export const PasswordSchema = z
	.string({ required_error: 'La contraseña es requerida' })
	.min(6, { message: 'La contraseña es demasiado corta' })
	.max(100, { message: 'La contraseña es demasiado larga' })

export const NameSchema = z
	.string({ required_error: 'El nombre es requerido' })
	.min(3, { message: 'El nombre es demasiado corto' })
	.max(40, { message: 'El nombre es demasiado largo' })

export const EmailSchema = z
	.string({ required_error: 'El correo electrónico es requerido' })
	.email({ message: 'El correo electrónico es inválido' })
	.min(3, { message: 'El correo electrónico es demasiado corto' })
	.max(100, { message: 'El correo electrónico es demasiado largo' })
	// los usuarios pueden escribir el correo electrónico en cualquier caso, pero lo almacenamos en minúsculas
	.transform(value => value.toLowerCase())

export const PhonenumberSchema = z
	.string({ required_error: 'El número de teléfono es requerido' })
	.min(3, { message: 'El número de teléfono es demasiado corto' })
	.max(15, { message: 'El número de teléfono es demasiado largo' })
	.regex(/^\+?[0-9]+$/, {
		message:
			'El número de teléfono solo puede incluir números. Incluye el código de país pero omite el signo más al principio. Por ejemplo, 51934567890',
	})
	.transform(value => value.replace(/\+/g, ''))

export const PasswordAndConfirmPasswordSchema = z
	.object({ password: PasswordSchema, confirmPassword: PasswordSchema })
	.superRefine(({ confirmPassword, password }, ctx) => {
		if (confirmPassword !== password) {
			ctx.addIssue({
				path: ['confirmPassword'],
				code: 'custom',
				message: 'Las contraseñas deben coincidir',
			})
		}
	})
